import styled from 'styled-components';

export const GoogleButtonWrapper = styled.div`
  margin-top: 16px;
  position: relative;
  width: 100%;
  height: 44px;
`;

export const GoogleButtonContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0;
  cursor: pointer;
`;

export const CustomGoogleButton = styled.button<{ customStyles?: string }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Google Sans', sans-serif;
  gap: 8px;
  padding: 10px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.custom?.googleBtnBg || '#FFFFFF'};
  border: 1px solid ${({ theme }) => theme.custom?.googleBtnBorder || '#DADCE0'};
  color: ${({ theme }) => theme.custom?.bodyColor || '#3C4043'};
  outline: none;
  font-weight: 500;
  letter-spacing: 0.25px;
  font-size: 14px;
  cursor: pointer;
  transition: opacity 0.2s;
  z-index: 2;
  pointer-events: none;
  max-width: 400px;
  margin: 0 auto;
  ${({ customStyles }) => customStyles || ''};
`;

export const GoogleLogo = styled.img`
  width: 24px;
  height: 24px;
`;

export const Separator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  font-size: 14px;
  color: #848484;
  width: 100%;

  span {
    margin: 0 10px;
    white-space: nowrap;
    flex: 1;
    text-align: center;
  }

  &::before,
  &::after {
    content: '';
    display: block;
    height: 1px;
    width: 100px;
    background-color: ${({ theme }) => theme.custom?.headerBorder || '#e9e9e9'};
  }
`;
